import React from "react";
import { BatchQualityValue, Quality, QualityColumnType, QualityValue } from "../Types/LotDetailQuality";
import { useTranslation } from 'react-i18next';
import DateColumn from "../DataTable/datatable.datecolumn";
import DataTable from "../DataTable/datatable.component";
import { DraggableModalDialog } from "./DraggableModalDialog";
import { Button, Modal } from "react-bootstrap";
import QualityColumn from "../Pages/LotDetails/LotDetailsComponents/QualtiesSection/QualityColumn";
import { QualityValueConfidenceColumn } from "../Pages/LotDetails/LotDetailsComponents/QualtiesSection/QualityValueConfidenceColumn";

export type BatchQualityTableProps = {
    quality: Quality,
    batchQualityValue: BatchQualityValue[],
    qualityColumns: QualityColumnType[]
};

function BatchQualitiyTables({ quality, batchQualityValue, qualityColumns }: BatchQualityTableProps) {

    const { t } = useTranslation();

    var tableData = batchQualityValue;

    const tableColumns: any[] = [
        {
            Header: t('BatchQualityDetail.BatchQuality.BatchNumber'),
            accessor: 'batchNumber'
        },
        DateColumn({ header: t('BatchQualityDetail.BatchQuality.StartTime'), accessor: 'batchStartTime', width: "15%" }),
        DateColumn({ header: t('BatchQualityDetail.BatchQuality.EndTime'), accessor: 'batchEndTime', width: "15%" }),
    ];

    // Add quality based columns (using the list of quality columns to decide what to add)
    qualityColumns.forEach((qualityColumnType) => {
        switch (qualityColumnType) { 
            case "Primary":
                tableColumns.push(QualityColumn({ header: t('LotDetails.Qualities.Primary'), qualityType: 'ASADDED' }));
                break;
            case "QualityValueConfidence":
                tableColumns.push(QualityValueConfidenceColumn());
                break;
            case "Manual":
                tableColumns.push(QualityColumn({ header: t('LotDetails.Qualities.Manual'), qualityType: 'ALTERNATE' }));
                break;
            case "LRL": // Release Limits don't make sense for individual results - show the minimum limit
            case "Min":
                tableColumns.push({
                    Header: t('LotDetails.Qualities.Min'),
                    Cell: (props: any) => quality.min
                });
                break;
            case "URL": // Release Limits don't make sense for individual results - show the maximum limit
            case "Max":
                tableColumns.push({
                    Header: t('LotDetails.Qualities.Max'),
                    Cell: (props: any) => quality.max
                });
                break;
            case "Target":
                tableColumns.push({
                    Header: t('LotDetails.Qualities.Target'),
                    Cell: (props: any) => quality.target
                });
                break;
        }
    });

    const initialState = {
        sortBy: [
            {
                id: 'batchStartTime',
                desc: false
            },
            {
                id: 'batchNumber',
                desc: false
            }
        ]
    };

    return (
        <DataTable
            id={`${quality}-batch-quality-table`}
            tableColumns={tableColumns}
            tableData={tableData}
            initialState={initialState}
            showPaging={false} />
    );
}

export type LabDetailsDialogProps = {
    quality: Quality,
    batchQualityValues: BatchQualityValue[],
    qualityColumns: QualityColumnType[],
    showDialog: boolean,
    closeDialog: () => void
};

function BatchQualityDetailsDialog({ showDialog, closeDialog, quality, batchQualityValues, qualityColumns }: LabDetailsDialogProps) {

    const { t } = useTranslation();

    return (
        <Modal dialogAs={DraggableModalDialog} className="detail-dialog" show={showDialog} onHide={closeDialog} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t('BatchQualityDetail.Title') + " - " + quality.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <BatchQualitiyTables quality={quality} batchQualityValue={batchQualityValues} qualityColumns={qualityColumns} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeDialog}>
                    {t("Application.Controls.Close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default BatchQualityDetailsDialog;